import { Link } from "react-router-dom";
import { brand } from "../lib/brand";

export function Logo({ withSchool = true }: { withSchool?: boolean } = {}) {
  if (brand.id === "aisthetics") {
    return (
      <Link to="/dashboard" className="logo logo--script" aria-label={brand.name}>
        AI-Sthetics
      </Link>
    );
  }

  return (
    <Link to="/dashboard" className="logo" aria-label="Dewviko School">
      <span>dew</span>
      <span className="logo__accent">viko</span>
      {withSchool && <span className="logo__sub">school</span>}
    </Link>
  );
}
